exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pupophHintOverlayer[data-v-0019a0fe] {\n  z-index: 9999;\n  /*background-color: rgba(0, 0, 0, .5);*/\n}\n.pupopLoading[data-v-0019a0fe] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n\n/*.pupopLoading div:first-child{*/\n\n/*margin: 0 auto;*/\n\n/*}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0019a0fe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/common/pupopLoading.vue
// module id = SRnA
// module chunks = 13